import { render } from "./insure-daily-claim.vue?vue&type=template&id=1a8b998a&scoped=true&ts=true"
import script from "./insure-daily-claim.vue?vue&type=script&lang=ts"
export * from "./insure-daily-claim.vue?vue&type=script&lang=ts"

import "./insure-daily-claim.vue?vue&type=style&index=0&id=1a8b998a&lang=stylus&scoped=true"

import exportComponent from "D:\\Repository\\Zidan\\pc-customer-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a8b998a"]])

export default __exports__